// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"e_rdb","title":"e_sdb","container":"e_tdb","list":"e_udb"};